import React from 'react'
import { Stack, Box, Typography } from '@mui/material'

export interface InfoRowProps {
  icon: React.ReactNode
  label: string
  value?: React.ReactNode
}

const InfoRow: React.FC<InfoRowProps> = ({ icon, label, value }) => (
  <Stack direction="row" spacing={1.5} sx={{ alignItems: 'center' }}>
    <Box sx={{ color: 'text.secondary', display: 'flex' }}>{icon}</Box>

    <Box>
      <Typography
        variant="caption"
        sx={{
          color: 'text.secondary',
          display: 'block',
          lineHeight: 1
        }}
      >
        {label}
      </Typography>

      <Typography variant="body2" sx={{ fontWeight: '500' }}>
        {value || 'N/A'}
      </Typography>
    </Box>
  </Stack>
)

export default InfoRow
